import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6740173e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-8 px-page path" }
const _hoisted_2 = { class: "px-content flex gap-cell items-center" }
const _hoisted_3 = { class: "icon-base p-mention clickable" }
const _hoisted_4 = { class: "path-item" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "self-center mention mx-cellpath-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_PageMention = _resolveComponent("PageMention")!
  const _component_FountainToggle = _resolveComponent("FountainToggle")!
  const _component_Profile = _resolveComponent("Profile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Icon, {
          icon: ['fal', `chevrons-${_ctx._hideNavbar ? 'right' : 'left'}`],
          class: "icon-sm path-item text-charcoal-ghost",
          onClick: _ctx.toggleNavbar
        }, null, 8, ["icon", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx._path.length > 4)
          ? (_openBlock(), _createBlock(_component_PageMention, {
              key: 0,
              class: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPage(_ctx._path[0]))),
              page: _ctx._path[0]
            }, null, 8, ["page"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx._path.length > 4)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            icon: ['fal', 'ellipsis'],
            class: "icon-base text-charcoal self-center path-item"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._path.slice(_ctx._path.length > 4 ? -3 : -1 * _ctx._path.length), (page) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex path-slash path-item",
            key: page
          }, [
            _createVNode(_component_PageMention, {
              onClick: ($event: any) => (_ctx.openPage(page)),
              page: page
            }, null, 8, ["onClick", "page"])
          ]))
        }), 128))
      ]),
      _hoisted_6,
      (_ctx._saving)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " saving... "))
        : _createCommentVNode("", true),
      _createVNode(_component_FountainToggle, {
        class: _normalizeClass(["mx-cell path-item", { fountain: _ctx._fountain }])
      }, null, 8, ["class"]),
      _createVNode(_component_Profile, {
        class: "path-item",
        onClick: _ctx.openProfile
      }, null, 8, ["onClick"])
    ])
  ]))
}